import { GroupDelegate, Relationship } from '@leverege/molten-core';
function getGroupRelationship(relationshipPaths, delegate) {
  const {
    relationship
  } = delegate || {};
  if (!relationship || !relationshipPaths) {
    return null;
  }
  const src = relationshipPaths.find(d => d.path === relationship.path);
  if (src && src.sourcePath) {
    const rel = Relationship.getByPath(src.sourcePath);
    if (rel) {
      return {
        relationship: rel.createResolved(delegate.match),
        match: delegate.match,
        objectType: rel.options.objectType
      };
    }
  }
  return null;
}
function getGroupDelegate(relationshipPaths, delegate, opts) {
  const rel = getGroupRelationship(relationshipPaths, delegate);
  return rel ? new GroupDelegate({
    ...rel,
    ttl: 30000,
    ...opts
  }) : delegate instanceof GroupDelegate ? new GroupDelegate({
    ...delegate,
    ttl: 30000,
    ...opts
  }) : null;
}
export default {
  getGroupRelationship,
  getGroupDelegate
};